export default {
    type: 'root',
    children: [
        {
            type: 'field',
            key: 'terminationDate',
            label: 'common.contract.termination-date',
            inputType: 'calendar',
            validators: [
                { type: 'required' },
                { type: 'date' },
                { type: 'isBeforeOrEqualToToday' },
            ],
        },
    ],
}
